



































import { Component, Vue } from 'vue-property-decorator'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


// These are the Interfaces for the Payload we want to send to the server.
interface CompetitorGoogleAddress {
    street: string;
    street2: string|null;
    city: string;
    state: string;
    zipcode: string;
    country: string;
}


interface CompetitorInformation {
    competitorName: string;
    address: CompetitorGoogleAddress|null;
    googlePlaceId: string;
    phoneNumber: string;
    website: string;
}


interface CompetitorPayload {
    pulsemAccountId: number|null;
    competitorInformation: CompetitorInformation|null;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard
    }
})
export default class CompetitorAnalysisToolkit extends Vue {
    locationValid = false
    pulsemAccountId: number|null = null
    competitorInformation: CompetitorInformation|null = {
        competitorName: '',
        address: {
            street: '',
            street2: null,
            city: '',
            state: '',
            zipcode: '',
            country: 'US'
        },
        googlePlaceId: '',
        phoneNumber: '',
        website: ''
    }

    /**
     * Everything that we send up to the server needs to be a string.
     * @returns { CompetitorPayload }
     */
    get payload(): CompetitorPayload {
        return {
            pulsemAccountId: this.pulsemAccountId,
            competitorInformation: this.competitorInformation
        }
    }

    /**
     * Data cleanup when switching between locations.
     * @param locationValid
     */
    async onLocationChange(locationValid: boolean) {
        this.locationValid = locationValid
        this.competitorInformation = {
            competitorName: '',
            address: {
                street: '',
                street2: null,
                city: '',
                state: '',
                zipcode: '',
                country: 'US'
            },
            googlePlaceId: '',
            phoneNumber: '',
            website: ''
        }
    }
}
